import React, {Component} from "react";
import { Layout, Collapse, Tabs } from 'antd';

import Header from "../../components/header";

import './basic.less'

const { Sider } = Layout;
const { Panel } = Collapse;
const { TabPane } = Tabs;

/**
 *基础知识的路由组件
 */
export default class Basic extends Component {

    state = {
        hide:"block"
    };

    hideDefault = (e) =>{
        if(e==="1"||e==="2"){
            let hide = this.state.hide;
            if(hide==="block"){
                this.setState({
                    hide: "none"
                })
            }
        }else {
            this.setState({
                hide: "block"
            })
        }
    };


    render(){
        return (
            <Layout style={{overflowY:"scroll"}}>
                <Header>Header</Header>
                <Layout style={{padding: '30px 0 0 0',background:'#fff'}} className='basic'>
                    <Sider>
                        <Collapse onChange={this.hideDefault} accordion>
                            <a className={"dot1"}/>
                            <Panel header="望神色形态" key="1">
                                <Tabs defaultActiveKey="11" tabPosition='left'>
                                    <TabPane tab="实训目的" key="111">
                                        <div className="facial_purpose content_all">
                                            <div className="basic_img">
                                                <img src={require('./images/basic1.png')} />
                                            </div>
                                            <div className="basic_content">
                                                <div className="basic_title">
                                                    望神色形态
                                                </div>
                                                <div className="basic_info">
                                                    <p>
                                                        望神色形态是医生通过观察患者的精神、面色、形体、姿态等全身情况， 对疾病的寒、热、虚、实和病情的轻
                                                        重缓急作出判断的一种方法，包括望神、望面色、望形体和望姿态四个方面。
                                                    </p>
                                                </div>
                                                <div className="basic_desc">
                                                    <h5>
                                                        实训目的
                                                    </h5>
                                                    <div>
                                                        <ol>
                                                            <li>
                                                                1.掌握望神、色、形、态的操作方法及注意事项。
                                                            </li>
                                                            <li>
                                                                2.熟悉神、色、形、态常见病理改变及其临床意义。
                                                            </li>
                                                        </ol>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </TabPane>
                                    <TabPane tab="实训方法" key="112">
                                        <Tabs defaultActiveKey="1121" tabPosition='right' className="facial_method">
                                            <TabPane tab="操作要点" key="11211">
                                                <div className="right_nav content_all">
                                                    <div>
                                                        <div className="facial_box">
                                                            <div className="facial_title tbg1">
                                                                1.望神
                                                            </div>
                                                            <div className="facial_con">
                                                                <p>
                                                                    (1)望神通常在刚接触病患时，通过短暂且有重点的观察做出对“神”初步判断，医者需以神会神，用心体会，一会即觉，切忌过泥；
                                                                </p>
                                                                <p>
                                                                    (2)望神主要从眼神、神情、气色、体态四个方面进行观察。
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="facial_box">
                                                            <div className="facial_title tbg2">
                                                                2.望色
                                                            </div>
                                                            <div className="facial_con">
                                                                <p>
                                                                    (1)重点观察面部皮肤的色调（青、赤、黄、白、黑）及光泽（荣润/枯槁）的变化；
                                                                </p>
                                                                <p>
                                                                    (2)先整体观察面部的色泽变化，再观察面部不同区域的色泽变化；
                                                                </p>
                                                                <p>
                                                                    (3)适当应用比较法辨别病色：
                                                                </p>
                                                                <p>
                                                                    ① 病患面色与周围健康人群常色的比较观察；
                                                                </p>
                                                                <p>
                                                                    ② 病患面色与自身其他部位正常肤色的比较观察。
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="facial_box">
                                                            <div className="facial_title tbg3">
                                                                3.望形态
                                                            </div>
                                                            <div className="facial_con">
                                                                <p>
                                                                    (1)望形体主要从病患的形体强弱、胖瘦及体质类型三个方面观察；
                                                                </p>
                                                                <p>
                                                                    (2)望姿态主要从病患的坐形、卧式、立姿、行态以及有无异常动作等方面进行观察。
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </TabPane>
                                            <TabPane tab="注意事项" key="11212">
                                                <div className="right_nav content_all">
                                                    <div>
                                                        <div className="facial_item">
                                                            <div className="facial_doc yellow">
                                                                <span>温度</span>
                                                            </div>
                                                            <div className="facial_dox yellow">
                                                                诊室温度过低或者过高，均会影响患者皮肤色泽以及肌肉状态，掩盖病情真相，因此全身望诊应在适宜的诊室温度下进行；
                                                            </div>
                                                        </div>
                                                        <div className="facial_item">
                                                            <div className="facial_doc blue">
                                                                <span>光线</span>
                                                            </div>
                                                            <div className="facial_dox ano">
                                                                望诊应在自然、柔和、充足的自然光线下进行，如自然光线不足，也可借助室内日光灯进行观察，但应注意室内光源给面色带来的影响，切勿使用有色光源，必要时可在自然光线下复查；
                                                            </div>
                                                        </div>
                                                        <div className="facial_item">
                                                            <div className="facial_doc red">
                                                                其他因素
                                                            </div>
                                                            <div className="facial_dox">
                                                                望诊时应注意遗传、种族、季节、环境、情绪、饮酒等非疾病因素对神色形态的影响。
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </TabPane>
                                        </Tabs>
                                    </TabPane>
                                    <TabPane tab="实训内容" key="113">
                                        <Tabs defaultActiveKey="1131" tabPosition='right' className="facial_sub">
                                            <TabPane tab="望神" key="11311">
                                                <div className="content_all right_nav">
                                                    <div className="facial_box">
                                                        <div className="facial_title tbg4">
                                                            1.望神观察重点
                                                        </div>
                                                        <table className="facial_table">
                                                            <tbody className="table1">
                                                            <tr>
                                                                <td rowSpan="11">
                                                                    望神内容
                                                                </td>
                                                                <td rowSpan="3">
                                                                    目光（重点）
                                                                </td>
                                                                <td>
                                                                    目光是否明亮
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    目珠运动是否灵活
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    视物是否清晰
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowSpan="4">
                                                                    神志
                                                                </td>
                                                                <td>
                                                                    神志是否清楚
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    思维是否有序
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    反应是否灵敏
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    表情是否自然
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowSpan="2">
                                                                    面色
                                                                </td>
                                                                <td>
                                                                    面部颜色（青、赤、黄、白、黑）
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    面部光泽（荣润还是枯槁）
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowSpan="2">
                                                                    形态
                                                                </td>
                                                                <td>
                                                                    形体（丰满还是消瘦）
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    动态（灵活还是失灵）
                                                                </td>
                                                            </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    <div className="facial_box">
                                                        <div className="facial_title tbg5">
                                                            2.神按其表现不同可分为得神、少神、失神、假神和神乱五种。
                                                        </div>
                                                        <table className="facial_table">
                                                            <tbody className="table2">
                                                            <tr>
                                                                <td>
                                                                    神的分类
                                                                </td>
                                                                <td>
                                                                    临床表现
                                                                </td>
                                                                <td>
                                                                    临床意义
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    得神
                                                                </td>
                                                                <td>
                                                                    目光明亮，目珠灵动，神志清楚，<br/>
                                                                    表情自然，面色荣润，含蓄隐隐，<br/>
                                                                    形体适中，体态自如。
                                                                </td>
                                                                <td>
                                                                    正气充足，脏腑精气充盛。
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    少神
                                                                </td>
                                                                <td>
                                                                    两目乏神，目珠少动，神志清楚，精神<br/>
                                                                    不振，面色少华，形体瘦削，或虽胖<br/>
                                                                    而肌肉松软。
                                                                </td>
                                                                <td>
                                                                    正气不足，脏腑精气轻度损伤。
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    失神
                                                                </td>
                                                                <td>
                                                                    目光晦暗、呆滞，精神萎靡，或神志昏迷，<br/>
                                                                    表情淡漠，面色无华，语声低微或错乱，<br/>
                                                                    呼吸微弱，形体羸瘦，动作艰难。
                                                                </td>
                                                                <td>
                                                                    正气大伤，脏腑精气衰竭。
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    假神
                                                                </td>
                                                                <td>
                                                                    目光晦暗、呆滞，突然转亮，浮光外露；<br/>
                                                                    神志昏迷突然变为神志清楚，精神躁动；不能语言，<br/>
                                                                    突然变为言语不休；面色晦暗，突然颧赤如妆；<br/>
                                                                    毫无食欲，突然变为思食索食，食欲增强。
                                                                </td>
                                                                <td>
                                                                    正气将脱，脏腑精气衰竭。
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    神乱
                                                                </td>
                                                                <td>
                                                                    常见焦虑恐惧、悲伤抑郁、狂躁妄动、抽搐神昏等。
                                                                </td>
                                                                <td>
                                                                    多见于癫病、狂病、痫病、脏躁等
                                                                </td>
                                                            </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </TabPane>
                                            <TabPane tab="望面色" key="11312">
                                                <div className="content_all right_nav">
                                                    <div className="facial_box">
                                                        <div className="facial_title tbg6">
                                                            1.常色与病色
                                                        </div>
                                                        <p>
                                                            面色分为常色和病色，常色应注意区分主色和客色，病色应辨别善色与恶色。
                                                        </p>
                                                        <table className="facial_table">
                                                            <tbody className="table3">
                                                            <tr>
                                                                <td className="td-c4">
                                                                    &nbsp;
                                                                </td>
                                                                <td className="td-c1">
                                                                    特 点
                                                                </td>
                                                                <td className="td-c2">
                                                                    分 类
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowSpan="2" className="td-c4">
                                                                    常色
                                                                </td>
                                                                <td rowSpan="2">
                                                                    明润、含蓄
                                                                </td>
                                                                <td>
                                                                    主色：与生俱来，一生基本不变的面部色泽，通常与种族或遗传因素有关
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    客色：非疾病因素所致的短暂的面色变化。如随着季节推移、时辰变化，地理环境、饮食情绪等因素的影响
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowSpan="2" className="td-c4">
                                                                    病色
                                                                </td>
                                                                <td rowSpan="2">
                                                                    晦暗、暴露
                                                                </td>
                                                                <td>
                                                                    善色：病色虽显但尚有光泽，表明脏腑精气未衰，胃气尚能上荣于面，多属新病、轻病、阳证，预后较好
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    恶色：病色暴露而晦暗、枯槁，是真脏色外露，表明脏腑精气衰败，胃气不能上荣于面，多属久病、重病、阴证，预后较差
                                                                </td>
                                                            </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    <div className="facial_box">
                                                        <div className="facial_title tbg7">
                                                            2.五色主病
                                                        </div>
                                                        <p>
                                                            病色有青、赤、黄、白、黑五种，分别提示不同脏腑和不同性质的疾病。
                                                        </p>
                                                        <table className="facial_table">
                                                            <tbody className="table4">
                                                            <tr>
                                                                <td className="td-c2" width="220">
                                                                    面 色
                                                                </td>
                                                                <td className="td-c3">
                                                                    临 床 意 义
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    青
                                                                </td>
                                                                <td>
                                                                    寒证、痛证、气滞、血瘀证和惊风
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowSpan="2">
                                                                    赤
                                                                </td>
                                                                <td>
                                                                    热证：满面通红——实热；两颧潮红——虚热
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    戴阳证：原本面色晦暗，突见两颧泛红如妆
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowSpan="2">
                                                                    黄
                                                                </td>
                                                                <td>
                                                                    脾虚：萎黄（面色淡黄无光泽）——脾胃虚弱，气血不足；黄胖（面色黄而虚浮）——脾虚湿盛
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    湿证：阳黄（黄疸者颜色鲜明如橘皮）——湿热；阴黄（黄疸者颜色晦暗如烟熏）——寒湿
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    白
                                                                </td>
                                                                <td>
                                                                    虚证、寒证、失血证：淡白无华——气血亏虚或失血证；㿠白（面色白而虚浮）——阳虚水泛
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    黑
                                                                </td>
                                                                <td>
                                                                    寒证、痛证、血瘀证（面色黧黑，肌肤甲错）、肾虚（面黑而暗淡——肾阳虚；面黑而干焦——肾阴虚）、水饮（眼眶周围色黑——肾虚水饮或寒湿带下）
                                                                </td>
                                                            </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </TabPane>
                                            <TabPane tab="望形体" key="11313">
                                                <div className="content_all right_nav ">
                                                    <div className="facial_box">
                                                        <div className="facial_title tbg8">
                                                            1.形体强弱
                                                        </div>
                                                        <div className="facial_con">
                                                            <p>
                                                                形体强弱主要从皮肤的润枯、肌肉的丰瘦、骨骼的粗细、胸廓的宽窄等方面反映出来。
                                                            </p>
                                                            <table>
                                                                <tbody>
                                                                <tr>
                                                                    <td valign="top">
                                                                        <div className="top_div">
                                                                            体强：
                                                                        </div>
                                                                    </td>
                                                                    <td style={{lineHeight: 2}}>
                                                                        指形体强壮，表现为皮肤润泽，肌肉充实，骨骼强壮，胸廓宽厚，精力充沛，食欲旺盛，提示内脏坚实，气血旺盛，抗病力强，不易患病；患病则易于治疗，预后较好。
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td valign="top">
                                                                        <div className="top_div">
                                                                            体弱：
                                                                        </div>
                                                                    </td>
                                                                    <td style={{lineHeight: 2}}>
                                                                        指形体衰弱，表现为皮肤枯槁，肌肉瘦削，骨骼细小，胸廓狭窄，精神萎靡，食欲不振，提示内脏脆弱，气血亏虚，抗病力弱，易于患病；患病则难于治疗，预后较差。
                                                                    </td>
                                                                </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                    <div className="facial_box">
                                                        <div className="facial_title tbg9">
                                                            2.形体胖瘦
                                                        </div>
                                                        <div className="facial_con">
                                                            <p>
                                                                正常人体形适中，各部组织匀称。过于肥胖或过于消瘦都可能是病理状态。观察形体胖瘦时，应注意与精神状态、食欲食量等结合起来综合判断。
                                                            </p>
                                                            <table>
                                                                <tbody>
                                                                <tr>
                                                                    <td valign="top">
                                                                        <div className="top_div">
                                                                            体胖：
                                                                        </div>
                                                                    </td>
                                                                    <td style={{lineHeight: 2}}>
                                                                        体胖能食，肌肉坚实，神旺有力者，多属形气有余，是精气充足、身体健康的表现；体胖食少，肉松皮缓，神疲乏力者，多属形盛气虚，是阳气不足、多痰多湿的表现，易患痰饮、中风、胸痹等病证。
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td valign="top">
                                                                        <div className="top_div">
                                                                            体瘦：
                                                                        </div>
                                                                    </td>
                                                                    <td style={{lineHeight: 2}}>
                                                                        体瘦食多，属中焦有火；体瘦食少，属中气虚弱。体瘦颧红，伴潮热盗汗、口咽干燥者，多属阴虚火旺的表现，易患肺痨等病。
                                                                    </td>
                                                                </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </TabPane>
                                            <TabPane tab="望姿态" key="11314">
                                                <div className="content_all right_nav">
                                                    <div className="facial_box">
                                                        <div className="facial_title tbg6">
                                                            1.动静姿态
                                                        </div>
                                                        <table className="facial_table">
                                                            <tbody className="table3 table5">
                                                            <tr>
                                                                <td>
                                                                    &nbsp;
                                                                </td>
                                                                <td>
                                                                    表 现
                                                                </td>
                                                                <td>
                                                                    病 机
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowSpan="4">
                                                                    坐形
                                                                </td>
                                                                <td>
                                                                    坐而喜俯，咳喘少气
                                                                </td>
                                                                <td>
                                                                    肺虚气少
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    坐而喜仰，胸胀气粗
                                                                </td>
                                                                <td>
                                                                    肺实气逆
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td style={{color:"#000"}}>
                                                                    但坐不得卧，卧则气逆
                                                                </td>
                                                                <td>
                                                                    咳喘肺胀，或饮停胸腹
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    但卧不能坐，坐则神疲晕眩
                                                                </td>
                                                                <td>
                                                                    眩晕病或夺气失血
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowSpan="4">
                                                                    卧式
                                                                </td>
                                                                <td>
                                                                    卧时向外，身轻能自转侧
                                                                </td>
                                                                <td>
                                                                    热证、实证、阳证
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    卧时向内，身重难以转侧
                                                                </td>
                                                                <td>
                                                                    寒证、虚证、阴证
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    卧时蜷屈成团
                                                                </td>
                                                                <td>
                                                                    阳虚怕冷
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    卧时仰面伸足
                                                                </td>
                                                                <td>
                                                                    阳盛发热
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowSpan="2">
                                                                    立姿
                                                                </td>
                                                                <td>
                                                                    站立不稳，其态似醉，并见眩晕
                                                                </td>
                                                                <td>
                                                                    肝风内动
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    不耐久站，站立时常欲依靠它物支撑
                                                                </td>
                                                                <td>
                                                                    气血虚衰
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowSpan="3">
                                                                    行态
                                                                </td>
                                                                <td>
                                                                    行走之际，突然停步，以手护心，不敢行动
                                                                </td>
                                                                <td>
                                                                    真心痛
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    以手护腰，弯腰曲背，行动艰难
                                                                </td>
                                                                <td>
                                                                    腰腿病
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    行走时身体震颤不定
                                                                </td>
                                                                <td>
                                                                    肝风内动
                                                                </td>
                                                            </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    <div className="facial_box">
                                                        <div className="facial_title tbg7">
                                                            2.异常动作
                                                        </div>
                                                        <table className="facial_table">
                                                            <tbody className="table4">
                                                            <tr>
                                                                <td style={{width:'50%'}}>
                                                                    异常动作
                                                                </td>
                                                                <td>
                                                                    临床意义
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    手足颤动
                                                                </td>
                                                                <td>
                                                                    热盛动风或虚风内动
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    手足蠕动
                                                                </td>
                                                                <td>
                                                                    虚风内动
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    四肢抽搐
                                                                </td>
                                                                <td>
                                                                    热极生风，或肝风夹痰所致，见于小儿惊风或痫病
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    角弓反张
                                                                </td>
                                                                <td>
                                                                    热极生风，多见于破伤风及小儿惊风
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    循衣摸床、撮空理线
                                                                </td>
                                                                <td>
                                                                    多因邪热亢盛，耗伤心阴，或久病大虚，元气将脱所致，为失神的恶候，属病危
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    手足软弱无力，活动受限而无痛
                                                                </td>
                                                                <td>
                                                                    痿病
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    关节疼痛，活动困难者
                                                                </td>
                                                                <td>
                                                                    痹证
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    卒然昏倒，四肢抽搐，口吐白沫，口中发出猪羊叫声，醒后如常人
                                                                </td>
                                                                <td>
                                                                    痫病
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    卒然昏倒，四肢厥冷，呼吸自续
                                                                </td>
                                                                <td>
                                                                    厥病
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    盛夏卒倒，伴面赤汗出者
                                                                </td>
                                                                <td>
                                                                    中暑
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    卒然昏倒，半身不遂，口眼㖞斜，语言不利者
                                                                </td>
                                                                <td>
                                                                    中风病
                                                                </td>
                                                            </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </TabPane>
                                        </Tabs>
                                    </TabPane>
                                </Tabs>
                            </Panel>

                            <a className={"dot2"}/>
                            <Panel header="望舌" key="2">
                                <Tabs defaultActiveKey="12" tabPosition='left'>
                                    <TabPane tab="实训目的" key="121">
                                        <div className="facial_purpose content_all tongue_purpose">
                                            <div className="basic_img">
                                                <img src={require('./images/basic2.png')}/>
                                            </div>
                                            <div className="basic_content">
                                                <div className="basic_title">
                                                    望舌
                                                </div>
                                                <div className="basic_info">
                                                    <p>
                                                        舌诊是观察病人舌质、舌苔、舌下络脉变化以诊察疾病的方法，属于局部望诊部分，是中医特色诊法之一。舌
                                                        犹如内脏的一面镜子，临床实践证明，舌象能较为客观地反映病位的深浅、病邪的性质、气血的盛衰、津液的盈亏、
                                                        病势的进退等，是临床辨证的重要依据。学习舌诊既要掌握望舌的基本方法，又要掌握舌诊的内容，反复训练，仔
                                                        细体会，才能逐步识别各种舌象。
                                                    </p>
                                                </div>

                                                <div className="basic_desc">
                                                    <h5>
                                                        实训目的
                                                    </h5>
                                                    <div>
                                                        <ol>
                                                            <li>
                                                                1.掌握望舌方法与望舌的内容。
                                                            </li>
                                                            <li>
                                                                2.掌握各种病理性舌象的特征和临床意义。
                                                            </li>
                                                        </ol>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </TabPane>
                                    <TabPane tab="实训方法" key="122" className="facial_method tongue_method">
                                        <Tabs defaultActiveKey="1221" tabPosition='right'>
                                            <TabPane tab="望舌体位伸舌姿势" key="12211">
                                                <div className="content_all right_nav">
                                                    <div className="facial_box">
                                                        <div className="facial_title tbg8">
                                                            1.望舌面
                                                        </div>
                                                        <div className="facial_con">
                                                            <p>
                                                                (1)受诊者采取坐位或仰卧位，面向自然光线，医生的姿势稍高于患者，以便俯视口舌部位。嘱患者伸舌时略扬起头，将舌自然地伸出口外，舌体放松，舌面平展，舌尖略向下，尽量张口使舌体充分暴露。
                                                            </p>
                                                            <p>
                                                                (2)伸舌用力过大、伸舌时间过长或舌体紧张卷曲，都会影响舌的气血运行从而引起舌色改变，或干湿度变化。
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="facial_box">
                                                        <div className="facial_title tbg9">
                                                            2.望舌下络脉
                                                        </div>
                                                        <div className="facial_con">
                                                            <p>
                                                                先让受诊者张口，将舌体向上颚方向翘起，舌尖可轻抵上颚，用力适中，使舌体保持自然松弛，充分显露舌下络脉。
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </TabPane>
                                            <TabPane tab="方法" key="12212">
                                                <div className="content_all right_nav">
                                                    <div className="facial_box">
                                                        <div className="facial_title tbg10">
                                                            1.望舌的次序
                                                        </div>
                                                        <div className="facial_con">
                                                            <p>
                                                                先看舌面的舌质，舌苔，最后观察舌下脉络。望舌面的顺序一般是先总体望舌，对舌舌体的颜色，胖瘦，运动等有个整体的印象，接着按照舌尖，舌中、舌边，舌根部依次观察局部的变化。
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="facial_box">
                                                        <div className="facial_title tbg11">
                                                            2.望舌的内容
                                                        </div>
                                                        <div className="facial_con">
                                                            <p>
                                                                望舌质主要观察舌质的颜色、外形、润燥、动态，还要注意有无破溃等；望舌苔主要观察舌苔的颜色、厚薄、润燥以及是否均匀、有无剥脱等。最后望舌下络脉，主要观察络脉的长短、粗细、颜色、分支及外形等。
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="facial_box">
                                                        <div className="facial_title tbg12">
                                                            3.望舌的时间
                                                        </div>
                                                        <div className="facial_con">
                                                            <p>
                                                                一次望舌的时间一般为10～15秒，望舌时间不宜过长。如果一次望舌判断不准，可让病人休息3～5分钟后，再望舌一次。
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="facial_box">
                                                        <div className="facial_title tbg13">
                                                            4.辅助诊查法
                                                        </div>
                                                        <div className="facial_con">
                                                            <p>
                                                                用消毒压舌板的边缘，以适中的力量，在舌面上由舌根向舌尖刮3～5次，为刮舌法，用于鉴别舌苔的有根或无根，是否为染苔。
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </TabPane>
                                            <TabPane tab="注意事项" key="12213">
                                                <div className="content_all right_nav">
                                                    <h5 className={"add_title"}>注意各种操作因素造成的虚假舌象，尽量减少和避免各种非疾病因素对舌象造成影响。</h5>
                                                    <div className="facial_item">
                                                        <div className="facial_doc yellow1">
                                                            <span>光线</span>
                                                        </div>
                                                        <div className="facial_dox ano">
                                                            光线的强弱与色调对颜色有极大的影响，容易造成错觉。白天以充足、柔和的自然光线为宜，夜晚或暗处可在日光灯下，光线要直射到舌面，避开有色物体的反光，避免有色光源照射。
                                                        </div>
                                                    </div>
                                                    <div className="facial_item">
                                                        <div className="facial_doc blue1">
                                                            <span>饮食或药物</span>
                                                        </div>
                                                        <div className="facial_dox">
                                                            饮食和某些药物可以使舌苔着色。若与病情不相符，发现疑问时，可询问病人的饮食、服药情况予以鉴别。
                                                        </div>
                                                    </div>
                                                    <div className="facial_item">
                                                        <div className="facial_doc orange">
                                                            <span>口腔</span>
                                                        </div>
                                                        <div className="facial_dox">
                                                            牙齿残缺，可造成同侧舌苔偏厚；睡觉时张口呼吸可使舌苔增厚、变干等。
                                                        </div>
                                                    </div>
                                                    <div className="facial_item">
                                                        <div className="facial_doc green">
                                                            <span>伸舌姿势</span>
                                                        </div>
                                                        <div className="facial_dox">
                                                            伸舌过分用力、舌体紧张卷曲均会影响舌的气血运行，从而引起舌色改变。伸舌过短，未充分张口，也不利于医生观察舌象。
                                                        </div>
                                                    </div>
                                                    <div className="facial_item">
                                                        <div className="facial_doc red1">
                                                            <span>就诊习惯</span>
                                                        </div>
                                                        <div className="facial_dox">
                                                            就诊前用牙刷刮舌面，人为使舌苔变薄；伸舌之前特意咽下口水，吞咽使口腔水分减少，舌苔干燥。
                                                        </div>
                                                    </div>
                                                </div>
                                            </TabPane>
                                        </Tabs>
                                    </TabPane>
                                    <TabPane tab="实训内容" key="123">
                                        <Tabs defaultActiveKey="1231" tabPosition='right' className="facial_method content_last">
                                            <TabPane tab="望舌质" key="12311">
                                                <div className="content_all right_nav">
                                                    <div className="facial_box">
                                                        <div className="facial_title tbg14">
                                                            1.望舌神
                                                        </div>
                                                        <div>
                                                            <p>
                                                                舌神是对舌的总体印象，主要观察舌的色泽与舌体运动两方面。
                                                            </p>
                                                            <table className="facial_table">
                                                                <tbody>
                                                                <tr>
                                                                    <td valign="top">
                                                                        <div>
                                                                            荣舌：
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        舌色红活明润，舌体活动自如。
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td valign="top">
                                                                        <div>
                                                                            枯舌：
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        舌色晦暗枯槁，舌体活动不灵。
                                                                    </td>
                                                                </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                    <div className="facial_box">
                                                        <div className="facial_title tbg15">
                                                            2.望舌色
                                                        </div>
                                                        <p>
                                                            舌色指舌质的颜色，包括全舌和局部的颜色。舌质的颜色是以红色为主要色调进行变化的。分为淡红舌、淡白舌、红舌、绛舌和青紫舌五种。
                                                        </p>
                                                        <table className="facial_table">
                                                            <tbody className="table6">
                                                            <tr>
                                                                <td>
                                                                    类 别
                                                                </td>
                                                                <td>
                                                                    异 常 表 现
                                                                </td>
                                                                <td colSpan="2">
                                                                    临 床 意 义
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    淡红舌
                                                                </td>
                                                                <td>
                                                                    以红为主，红中带白或红白适中
                                                                </td>
                                                                <td colSpan="2">
                                                                    气血调和之征象，常见于正常人或疾病轻浅之时
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    淡白舌
                                                                </td>
                                                                <td>
                                                                    颜色比淡红舌浅淡，白色偏多红色偏少
                                                                </td>
                                                                <td colSpan="2">
                                                                    气血两虚，阳虚
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    红舌
                                                                </td>
                                                                <td>
                                                                    较正常舌色红，或呈鲜红色，纯红无白
                                                                </td>
                                                                <td colSpan="2">
                                                                    实热，阴虚内热
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    绛舌
                                                                </td>
                                                                <td>
                                                                    较红舌颜色更深，或略带暗红色
                                                                </td>
                                                                <td colSpan="2">
                                                                    里热亢盛，阴虚火旺
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowSpan="2">
                                                                    青紫舌
                                                                </td>
                                                                <td rowSpan="2">
                                                                    全舌色淡紫而无红色，为青舌。<br/>
                                                                    舌色深绛而色暗，为紫舌。<br/>
                                                                    其中舌淡而泛现青紫者，为淡紫舌；<br/>
                                                                    舌红而泛现紫色者，为紫红舌；<br/>
                                                                    舌绛而现紫色者，为绛紫舌；<br/>
                                                                    舌体局部出现紫色斑点，大小不等，<br/>
                                                                    称为紫斑或紫点
                                                                </td>
                                                                <td rowSpan="2">
                                                                    主气血运行不畅
                                                                </td>
                                                                <td>
                                                                    瘀血较重，多是全身性瘀血
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    瘀血程度较轻，多见于瘀血阻滞局部，或局部脉络损伤所致
                                                                </td>
                                                            </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    <div className="facial_box">
                                                        <div className="facial_title tbg16">
                                                            3.望舌形
                                                        </div>
                                                        <p>
                                                            舌形，指舌质的形状，包括老嫩、胖瘦、齿痕、点刺、裂纹等方面的特征,老嫩、胖瘦主要是全舌的形状，齿痕、点刺、裂纹多是舌质局部的变化。
                                                        </p>
                                                        <table className="facial_table">
                                                            <tbody className="table7">
                                                            <tr>
                                                                <td colSpan="2">
                                                                    类 别
                                                                </td>
                                                                <td>
                                                                    异 常 表 现
                                                                </td>
                                                                <td>
                                                                    临 床 意 义
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowSpan="2">
                                                                    老嫩
                                                                </td>
                                                                <td>
                                                                    老舌
                                                                </td>
                                                                <td>
                                                                    舌质纹理粗糙，坚敛苍老
                                                                </td>
                                                                <td>
                                                                    实证
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    嫩舌
                                                                </td>
                                                                <td>
                                                                    舌质纹理细腻，浮胖娇嫩，舌色浅淡
                                                                </td>
                                                                <td>
                                                                    虚证
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowSpan="3">
                                                                    胖瘦
                                                                </td>
                                                                <td>
                                                                    胖大舌
                                                                </td>
                                                                <td>
                                                                    舌体比正常大而厚，伸舌满口
                                                                </td>
                                                                <td>
                                                                    水湿内停
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    肿胀舌
                                                                </td>
                                                                <td>
                                                                    舌体肿大满嘴，甚至不能闭口，舌肌胀急
                                                                </td>
                                                                <td>
                                                                    酒毒或热毒上壅
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    瘦薄舌
                                                                </td>
                                                                <td>
                                                                    舌体比正常小而薄
                                                                </td>
                                                                <td>
                                                                    气血两虚，阴虚火旺
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowSpan="2">
                                                                    点刺
                                                                </td>
                                                                <td>
                                                                    点舌
                                                                </td>
                                                                <td>
                                                                    突起于舌面的红色、紫红色或黑色星点
                                                                </td>
                                                                <td rowSpan="2">
                                                                    脏腑阳热亢盛，或为血分热盛
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    芒刺舌
                                                                </td>
                                                                <td>
                                                                    舌乳头突起如芒刺，摸之棘手
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan="2">
                                                                    裂纹舌
                                                                </td>
                                                                <td>
                                                                    舌面上有明显裂沟，而裂沟中并无舌苔覆盖
                                                                </td>
                                                                <td>
                                                                    热盛、阴虚、血虚等
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan="2">
                                                                    齿痕舌
                                                                </td>
                                                                <td>
                                                                    舌边缘有牙齿压迫的痕迹，多伴舌体胖大
                                                                </td>
                                                                <td>
                                                                    脾虚，水湿内盛
                                                                </td>
                                                            </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    <div className="facial_box">
                                                        <div className="facial_title tbg17">
                                                            4.望舌态
                                                        </div>
                                                        <p>
                                                            舌态，指舌体的动态。常见的病理舌态包括痿软、强硬、歪斜、颤动、吐弄、短缩等。望舌态时要注意受检者面部的表情、动态，还要结合言语进行判断。
                                                        </p>
                                                        <table className="facial_table">
                                                            <tbody className="table8">
                                                            <tr>
                                                                <td>
                                                                    类 别
                                                                </td>
                                                                <td>
                                                                    异 常 表 现
                                                                </td>
                                                                <td>
                                                                    临 床 意 义
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    痿软舌
                                                                </td>
                                                                <td>
                                                                    舌体伸缩软弱无力
                                                                </td>
                                                                <td>
                                                                    阴虚或气血俱虚
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    强硬舌
                                                                </td>
                                                                <td>
                                                                    舌失柔和，屈伸不利，或不能转动
                                                                </td>
                                                                <td>
                                                                    热入心包，高热伤津、风痰阻络
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    歪斜舌
                                                                </td>
                                                                <td>
                                                                    伸舌时舌体偏向一侧，或左或右
                                                                </td>
                                                                <td>
                                                                    中风或中风先兆
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    颤动舌
                                                                </td>
                                                                <td>
                                                                    舌体不自觉的震颤抖动
                                                                </td>
                                                                <td>
                                                                    肝风内动
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    吐弄舌
                                                                </td>
                                                                <td>
                                                                    吐舌：舌伸出口外，久不回缩者；<br/>
                                                                    弄舌：舌反复吐而即回，或舐口唇四周，掉动不宁
                                                                </td>
                                                                <td>
                                                                    心脾有热
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    短缩舌
                                                                </td>
                                                                <td>
                                                                    舌体卷短、紧缩，不能伸长
                                                                </td>
                                                                <td>
                                                                    寒凝、痰阻、血虚、津伤
                                                                </td>
                                                            </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    <div className="facial_box">
                                                        <div className="facial_title tbg18">
                                                            5.对舌下脉络的判断
                                                        </div>
                                                        <div>
                                                            <p>
                                                                (1)舌下络脉位于舌系带两侧纵行的大络脉。主要观察舌系带两侧的大络脉粗细、色泽、长度和形态，有否怒张、弯曲等异常改变，然后再观察周围细小络脉的颜色、形态是否有异常。
                                                            </p>
                                                            <p>
                                                                (2)舌下络脉粗张、分叉，长度超过舌尖至舌下肉阜连线的五分之三，呈现青紫、绛、绛紫、紫黑色，或细小呈暗红色或紫色网格，或曲张如紫色珠子状大小不等的结节，为血瘀之征。
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </TabPane>
                                            <TabPane tab="望舌苔" key="12312">
                                                <Tabs defaultActiveKey="1" className="last_tab" tabPosition='right'>
                                                    <TabPane tab="• 望苔质" key="1">
                                                        <div className="content_all right_nav">
                                                            <p>
                                                                <strong style={{fontSize:'24px'}}><span style={{color:'#ff9e00'}}>望苔质</span></strong>
                                                            </p>
                                                            <p style={{marginBottom:'20px',fontSize:'18px'}}>
                                                                苔质指舌苔的质地、形态。主要观察舌苔的厚薄、润燥、腻腐、剥落、偏全、真假方面变化。
                                                            </p>
                                                            <div className="facial_box">
                                                                <div className="facial_title tbg19">
                                                                    1.厚薄苔
                                                                </div>
                                                                <p>
                                                                    主要反映邪正的盛衰和病位的浅深。
                                                                </p>
                                                                <table className="facial_table">
                                                                    <tbody className="table11">
                                                                    <tr>
                                                                        <td>
                                                                            类 别
                                                                        </td>
                                                                        <td>
                                                                            舌 象
                                                                        </td>
                                                                        <td>
                                                                            临 床 意 义
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>
                                                                            薄苔
                                                                        </td>
                                                                        <td>
                                                                            透过舌苔能见到舌体，即可以见底的
                                                                        </td>
                                                                        <td>
                                                                            胃有生发之气，或主表证、轻证
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>
                                                                            厚苔
                                                                        </td>
                                                                        <td>
                                                                            透过舌苔不能见到舌体，即不能见底
                                                                        </td>
                                                                        <td>
                                                                            主邪盛入里，或内有痰湿、食积、里热
                                                                        </td>
                                                                    </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                            <div className="facial_box">
                                                                <div className="facial_title tbg20">
                                                                    2.润燥苔
                                                                </div>
                                                                <p>
                                                                    舌苔润燥主要反映体内津液盈亏和输布情况。
                                                                </p>
                                                                <table className="facial_table">
                                                                    <tbody className="table12">
                                                                    <tr>
                                                                        <td className="td-c2">
                                                                            类 别
                                                                        </td>
                                                                        <td className="td-c3">
                                                                            舌 象
                                                                        </td>
                                                                        <td className="td-c4">
                                                                            临 床 意 义
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="td-c2">
                                                                            润苔
                                                                        </td>
                                                                        <td>
                                                                            舌苔润泽有津，干湿适中
                                                                        </td>
                                                                        <td>
                                                                            正常，津液未伤
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="td-c2">
                                                                            滑苔
                                                                        </td>
                                                                        <td>
                                                                            舌面湿润而滑，伸舌欲滴
                                                                        </td>
                                                                        <td>
                                                                            痰饮、水湿
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="td-c2">
                                                                            燥苔
                                                                        </td>
                                                                        <td>
                                                                            舌苔干燥少津
                                                                        </td>
                                                                        <td>
                                                                            津液已伤
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="td-c2">
                                                                            糙苔
                                                                        </td>
                                                                        <td>
                                                                            苔质干燥粗糙，扪之碍手
                                                                        </td>
                                                                        <td>
                                                                            津伤已极
                                                                        </td>
                                                                    </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                            <div className="facial_box">
                                                                <div className="facial_title tbg21">
                                                                    3.腻腐苔
                                                                </div>
                                                                <p>
                                                                    主要测阳气与湿浊的消长。
                                                                </p>
                                                                <table className="facial_table">
                                                                    <tbody>
                                                                    <tr>
                                                                        <td className="td-c3">
                                                                            类 别
                                                                        </td>
                                                                        <td className="td-c4">
                                                                            舌 象
                                                                        </td>
                                                                        <td className="td-c2">
                                                                            临 床 意 义
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="td-c3">
                                                                            腻苔
                                                                        </td>
                                                                        <td>
                                                                            苔质颗粒细腻致密，融合成片，如油腻之状，紧贴舌面，中厚边周薄，刮之难去
                                                                        </td>
                                                                        <td>
                                                                            主湿浊、痰饮、食积
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="td-c3">
                                                                            腐苔
                                                                        </td>
                                                                        <td>
                                                                            苔质疏松，颗粒较大，形如豆腐渣堆积舌面，边中皆厚，揩刮易去
                                                                        </td>
                                                                        <td>
                                                                            痰浊、食积
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="td-c3">
                                                                            松苔
                                                                        </td>
                                                                        <td>
                                                                            苔质疏松，颗粒明显者
                                                                        </td>
                                                                        <td>
                                                                            湿浊之邪欲解的征象
                                                                        </td>
                                                                    </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                            <div className="facial_box">
                                                                <div className="facial_title tbg22">
                                                                    4.剥苔、类剥苔
                                                                </div>
                                                                <p>
                                                                    舌苔有无、消长及剥落变化，不仅能测知胃气、胃阴的存亡，亦可反映邪正盛衰，判断疾病的预后。
                                                                    如舌苔从全到剥，是正气渐衰的表现；舌苔剥落后，复生薄白之苔，乃邪去正胜，胃气渐复的佳兆。
                                                                </p>
                                                                <table className="facial_table">
                                                                    <tbody>
                                                                    <tr>
                                                                        <td className="td-c4">
                                                                            类 别
                                                                        </td>
                                                                        <td className="td-c1">
                                                                            舌 象
                                                                        </td>
                                                                        <td className="td-c2">
                                                                            临 床 意 义
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="td-c4">
                                                                            镜面舌
                                                                        </td>
                                                                        <td>
                                                                            舌苔全部剥脱，舌面光洁如镜
                                                                        </td>
                                                                        <td>
                                                                            色红者为胃阴干涸，胃无生发之气；色枯白如镜，毫无血色者主营血大亏，阳气将脱
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="td-c4">
                                                                            花剥苔
                                                                        </td>
                                                                        <td>
                                                                            舌面多处苔剥脱，仅参差不一、残存少许舌苔者
                                                                        </td>
                                                                        <td rowSpan="2">
                                                                            舌红苔剥多为阴虚；舌淡苔剥多为血虚或气血两虚；未剥落处仍有腻苔或滑苔者，多为正气已虚，湿浊之邪未化
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="td-c4">
                                                                            地图舌
                                                                        </td>
                                                                        <td>
                                                                            舌苔剥脱不规则，界限清楚，形似地图，部位时有转移者
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="td-c4">
                                                                            类剥苔
                                                                        </td>
                                                                        <td>
                                                                            舌苔剥脱处，可见新生苔质颗粒
                                                                        </td>
                                                                        <td>
                                                                            主久病气血不续
                                                                        </td>
                                                                    </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                            <div className="facial_box">
                                                                <div className="facial_title tbg23">
                                                                    5.偏全苔
                                                                </div>
                                                                <p>
                                                                    察舌苔分布的偏全，可诊病变之所在。
                                                                </p>
                                                                <table className="facial_table">
                                                                    <tbody>
                                                                    <tr>
                                                                        <td className="td-c5">
                                                                            类 别
                                                                        </td>
                                                                        <td className="td-c3">
                                                                            舌 象
                                                                        </td>
                                                                        <td className="td-c2">
                                                                            临 床 意 义
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="td-c5">
                                                                            全苔
                                                                        </td>
                                                                        <td>
                                                                            舌苔遍布舌面
                                                                        </td>
                                                                        <td>
                                                                            邪气弥漫，多为湿邪、痰浊内阻
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="td-c5">
                                                                            偏外苔
                                                                        </td>
                                                                        <td>
                                                                            舌苔仅布于舌尖
                                                                        </td>
                                                                        <td>
                                                                            邪气入里未深，而胃气先伤
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="td-c5">
                                                                            偏内苔
                                                                        </td>
                                                                        <td>
                                                                            舌苔仅布于舌根
                                                                        </td>
                                                                        <td>
                                                                            表邪虽减，胃滞依然
                                                                        </td>
                                                                    </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                            <div className="facial_box">
                                                                <div className="facial_title tbg24">
                                                                    6.真假苔
                                                                </div>
                                                                <p>
                                                                    判断疾病的轻重与预后。
                                                                </p>
                                                                <table className="facial_table">
                                                                    <tbody>
                                                                    <tr>
                                                                        <td className="td-c6">
                                                                            类 别
                                                                        </td>
                                                                        <td className="td-c3">
                                                                            舌 象
                                                                        </td>
                                                                        <td className="td-c2">
                                                                            临 床 意 义
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="td-c6">
                                                                            真苔（有根苔）
                                                                        </td>
                                                                        <td>
                                                                            舌体和舌苔不可分离，说明有根。采用刮舌法，如果舌苔紧贴舌面，刮之难去，刮后仍留有苔迹，不露舌质
                                                                        </td>
                                                                        <td>
                                                                            胃气上蒸胃阴，或湿邪、食浊上泛病之后期见真苔为胃气尚存
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="td-c6">
                                                                            假苔（无根苔）
                                                                        </td>
                                                                        <td>
                                                                            舌苔不紧贴舌面，如涂舌上，容易刮脱，刮后舌质光洁无苔
                                                                        </td>
                                                                        <td>
                                                                            胃气匮乏
                                                                        </td>
                                                                    </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </TabPane>
                                                    <TabPane tab="• 望苔色" key="2">
                                                        <div className="content_all right_nav">
                                                            <div className="facial_box">
                                                                <div className="facial_title tbg19">
                                                                    1.望苔色
                                                                </div>
                                                                <p>
                                                                    苔色指舌苔的颜色，主要有白苔、黄苔、灰黑苔三类，即可单独出现，也可同时出现，she 苔颜色变化可出现于全舌，也可在局部。判断苔色时要注意询问受检者就诊前饮食和服药情况。
                                                                </p>
                                                                <table className="facial_table">
                                                                    <tbody className="table12">
                                                                    <tr>
                                                                        <td colSpan="2" className="td-c4">
                                                                            类 别
                                                                        </td>
                                                                        <td className="td-c3">
                                                                            舌象
                                                                        </td>
                                                                        <td className="td-c5" colSpan="2" >
                                                                            临 床 意 义
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td rowSpan="3" className="td-c4">
                                                                            白苔
                                                                        </td>
                                                                        <td className="td-c4 td-pad">
                                                                            薄白苔
                                                                        </td>
                                                                        <td>
                                                                            舌上薄薄的分布一层白色舌苔，透过舌苔可以看到舌体
                                                                        </td>
                                                                        <td colSpan="2" >
                                                                            正常舌苔，疾病情况下主表证、寒症
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="td-c4 td-pad">
                                                                            厚白苔
                                                                        </td>
                                                                        <td>
                                                                            苔白而舌边尖稍薄，中根部较厚，舌体被舌苔遮盖而不能透出者
                                                                        </td>
                                                                        <td colSpan="2" >
                                                                            湿症
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="td-c4 td-pad">
                                                                            积粉苔
                                                                        </td>
                                                                        <td>
                                                                            苔白如积粉，扪之不燥者
                                                                        </td>
                                                                        <td colSpan="2" >
                                                                            湿病秽浊湿邪与热毒相结
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td rowSpan="3" className="td-c4">
                                                                            黄苔
                                                                        </td>
                                                                        <td className="td-c4 td-pad">
                                                                            淡黄苔
                                                                        </td>
                                                                        <td>
                                                                            又称微黄苔，是在薄白苔上出现均匀的浅黄色
                                                                        </td>
                                                                        <td rowSpan="3" className="td-pad" style={{width:200}}>
                                                                            主热症、里证
                                                                        </td>
                                                                        <td>
                                                                            热轻
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="td-c4 td-pad">
                                                                            深黄苔
                                                                        </td>
                                                                        <td>
                                                                            又称正黄苔，苔色黄而略深厚
                                                                        </td>
                                                                        <td>
                                                                            热重
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="td-c4 td-pad">
                                                                            焦黄苔
                                                                        </td>
                                                                        <td>
                                                                            又称老黄苔，是正黄色中夹有灰褐色苔
                                                                        </td>
                                                                        <td>
                                                                            热极
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td rowSpan="2" className="td-c4">
                                                                            灰、黑苔
                                                                        </td>
                                                                        <td className="td-c4 td-pad">
                                                                            灰苔
                                                                        </td>
                                                                        <td>
                                                                            苔色浅黑
                                                                        </td>
                                                                        <td rowSpan="2" colSpan="2" >
                                                                            邪热炽盛，或阴寒内盛，痰湿久郁等症，灰黑色浅而润多主寒；色深而燥多主热
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="td-c4 td-pad">
                                                                            黑苔
                                                                        </td>
                                                                        <td>
                                                                            苔色深黑
                                                                        </td>
                                                                    </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </TabPane>
                                                </Tabs>
                                            </TabPane>
                                        </Tabs>
                                    </TabPane>
                                </Tabs>
                            </Panel>
                        </Collapse>
                    </Sider>
                    <div className="main" style={{display:this.state.hide}}>
                        <div className="knowledge">
                            <div className="img">
                                <img src={require("./images/indexpage-img.png")}/>
                            </div>
                            <div className="content">
                                <div className="title">望诊</div>
                                <div className="desc">
                                    <p>
                                        望诊是医生运用视觉观察病人全身和局部的神色形态、舌象及排出物等以了解病情的一种诊察方法。
                                    </p>
                                    <p>
                                        长期的医疗实践证明，体内脏腑、经络、气血的生理活动及其病理变化，
                                        必然有相应的临床征象反映于外。因此，通过观察机体外部的神色形态变化，即可测知机体内部的生理病理改变。“望而知之为之神”,望诊居于中医四诊之首，是其他诊断方法所不可替代的。
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </Layout>
            </Layout>
        )
    }
}